import { useEffect } from 'react';
import { useSendReferer } from '../../hooks/useSendReferer';
import { FilterContainer } from '../../state/filters';
import { UiContainer } from '../../state/ui';
import { Icon, menu } from '../Icon/Icon';
import { CartButton } from './CartButton/CartButton';
import './Header.css';
import { HideOnScroll } from './HideOnScroll/HideOnScroll';
import { HeaderLogo } from './Logo/HeaderLogo';
import { NavigationDropdown } from './NavigationDropdown/NavigationDropdown';
import { SearchFormLoop54 } from './SearchFormLoop54/SearchFormLoop54';
import { TopBanner } from './TopBanner/TopBanner';
import { TopHeader } from './TopHeader/TopHeader';

export const Header = (): JSX.Element => {
	useSendReferer();
	const ui = UiContainer.useContainer();
	const { getNumOfAppliedFilters } = FilterContainer.useContainer();
	const filtersApplied = getNumOfAppliedFilters() > 0;
	const filterButtonsTriggerHeight =
		ui.categoryHasDescription && ui.categoyHasExpandableDescription ? 405 : ui.categoryHasDescription ? 370 : 260;

	useEffect(() => {
		function scrollListener() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			const stickyHeaderTriggerHeight = 70;
			const headerShouldBeSticky = scrollTop >= stickyHeaderTriggerHeight;
			const filterButtonsShouldBeSticky = scrollTop >= filterButtonsTriggerHeight && filtersApplied;

			if (ui.isFilterButtonsSticky !== filterButtonsShouldBeSticky) {
				ui.setStickyFilterButtons(filterButtonsShouldBeSticky);
			}
			if (ui.isHeaderSticky !== headerShouldBeSticky) {
				ui.setStickyHeader(headerShouldBeSticky);
			}
		}

		window.addEventListener('scroll', scrollListener);

		return () => window.removeEventListener('scroll', scrollListener);
	});

	return (
		<>
			<div id="header-background-underlay" className={`${ui.isHeaderSticky ? 'sticky' : ''}`} />
			<header className={`${ui.isHeaderSticky ? 'sticky' : ''}`}>
				<TopHeader />
				<div className="row not-mobile">
					<div className="logo-wrapper">
						<HeaderLogo />
					</div>
					<SearchFormLoop54 />
					<NavigationDropdown />
					<CartButton />
				</div>
				<div className="topbar-mobile only-mobile">
					<div className="mobile-only">
						<TopBanner applyMobileOffset />
					</div>
					<div className="topbar-mobile-wrapper">
						<div className="logo">
							<HeaderLogo />
						</div>
						<div className="my-page-icon">
							<NavigationDropdown />
						</div>
						<div className="cart-button-mobile">
							<CartButton />
						</div>
					</div>
				</div>
				<HideOnScroll>
					<div className="hamburger">
						<div className="clear menu" onClick={ui.toggleMenu}>
							<Icon size={32} shape={menu} />
						</div>
					</div>
					<div className="only-mobile">
						<SearchFormLoop54 />
					</div>
				</HideOnScroll>
			</header>
			<div className="mobile-header-spacing" />
		</>
	);
};
